import { t } from '@avalara/bat-apps-shared/i18n';
import { FlexContainerRowLRPadding, PageWrapper } from '../styled/skylab/page';

const LoginPrompt = () => (
  <PageWrapper>
    <FlexContainerRowLRPadding>
      <h2 className='pad-bottom-lg'>{t('client.headings.you-may-be-redirected-to-log-in')}</h2>
    </FlexContainerRowLRPadding>
  </PageWrapper>
);

export default LoginPrompt;
